/**
 * @author bgr
 */
import { send as sendMetric } from "./Metric";
import { store } from "../components/hotel-list/DataStore";

let lastDuration = null;

/* @see MetricController */
function getMetricByCount(count) {
	if (count <= 5) {
		return "hotel-list-prices-duration-5";
	}
	if (count <= 20) {
		return "hotel-list-prices-duration-20";
	}
	if (count <= 50) {
		return "hotel-list-prices-duration-50";
	}
	if (count <= 100) {
		return "hotel-list-prices-duration-100";
	}
	if (count <= 250) {
		return "hotel-list-prices-duration-250";
	}
	if (count <= 500) {
		return "hotel-list-prices-duration-500";
	}
	return "hotel-list-prices-duration-500plus";
}

function update(state) {
	if (
		state.lastPricesResetDuration !== null &&
		state.lastPricesResetDuration !== lastDuration
	) {
		lastDuration = state.lastPricesResetDuration;
		let count = Object.keys(state.prices).length;
		sendMetric(getMetricByCount(count), lastDuration / count);
	}
}

store.subscribe(update);
